$(document).ready(function() {  
    function getUTMAttributes() {
      // Retrieve UTMAttributes from Shopify cookie
      var shopifyCookieRegEx = /^_shopify_sa_p/;
      var utmRegEx = /^utm_/;
      var timestampRegEx = /^_shopify_sa_t/;
      var utmParams = {};
      var shopifyCookie = "";
      var timestamp = "";
      document.cookie.split(";")
      .map(function(s){
        return s.trim();
      })
      .forEach(function(s){
        if (shopifyCookieRegEx.test(s)) {
          shopifyCookie = s;
        }
        if (timestampRegEx.test(s)) {
          timestamp = decodeURIComponent(s.split("=")[1]);
        }
        return;
      });
      var utmValuesFromCookie = shopifyCookie.split("=")[1];
      decodeURIComponent(utmValuesFromCookie)
      .split("&")
      .forEach(function(s){
        var key = s.split("=")[0];
        var val = decodeURIComponent(s.split("=")[1]);
        if (utmRegEx.test(key)) {
          return utmParams[key] = val;
        }
        return;
      });
      if (!Object.keys(utmParams).length) {
        return undefined;
      }
      utmParams.utm_timestamp = timestamp;
      utmParams.utm_data_source = "shopify_cookie";
      return utmParams;
    }
    
      // Initialize datepicker --------------------
      if (window.innerWidth > 480) {
          var datemin = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
      } else {
          var datemin = ["S", "M", "T", "W", "T", "F", "S"];
      }  
      var today = new Date();
  
      $("#datepicker-gift-email-date").datepicker({
          minDate: today,
          selectOtherMonths: true,
          constrainInput: true,
          nextText: '<i class="fas fa-chevron-right"></i>',
          prevText: '<i class="fas fa-chevron-left"></i>',
          dateFormat: "MM d, yy",
          dayNamesMin: datemin
      });
  
      $("#datepicker-shipping-date").datepicker({
          minDate: today,
          beforeShowDay: $.datepicker.noWeekends,
          selectOtherMonths: true,
          constrainInput: true,
          nextText: '<i class="fas fa-chevron-right"></i>',
          prevText: '<i class="fas fa-chevron-left"></i>',
          dateFormat: "MM d, yy",
          dayNamesMin: datemin
      });  
  
      //Create Cookie Function --------------------
      var cookieCreate = function(name, value, days) {
          if (days) {
              var date = new Date();
              date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
              var expires = "; expires=" + date.toGMTString();
          } else {
              var expires = "";
          }
          document.cookie = name + "=" + value + expires + "; path=/";
      }
  
      //Read Cookie Function --------------------------
      var cookieRead = function(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
              var c = ca[i];
              while (c.charAt(0) == ' ') c = c.substring(1, c.length);
              if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
          }
          return null;
      }
  
      //Erase Cookie Function --------------------------
      var cookieErase = function(name) {
          cookieCreate(name, "", -1);
      }
  
      // Email validation function ---------------------
      var isEmail = function(email) {
          var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          return regex.test(email);
      }
  
      // Function to set variant id from variant title ----------------
      var setVariant = function(variant_title){
        // console.log(variant_title);
        $(".variant-id option").removeAttr('selected');
        // $(".variant-id option").filter(function() {
        //     // console.log($(this).text()+' ==== '+variant_title);
        //     return $(this).text() == variant_title;
        // }).attr('selected', 'selected');
        var found = false;
        $('.product-radio:checked').parents('.swatch-item').find(".variant-id option").each(function() {
          if($(this).text() == variant_title){
            $(this).attr('selected', 'selected');
            found = true;
            console.log($(this).text(),$(this).val());
            // console.log($(this).val());
            $('#btnCheckout').removeClass('disabled').prop("disabled",false);
          }
        });
        if(found == false){
          $('#btnCheckout').addClass('disabled').prop("disabled",true);
          // alert('Selected items is not avaiable, Choose another item!');
          return false;
        }
      };

      var getStyleTitle = function(){
        var quantity = $("input[name='option-quantity']:checked").val();
        // var style_title = quantity == 1 ? $("input[name='option-style']:checked").val() : '1 of each'; 
        var style_title = $("input[name='option-quantity']:checked").val(); 
        return style_title;
      };

      // Function to show/hide quantity based on size selection ---------------------
      var showHideQuantity = function(size_title){
        if(size_title.includes("kid's")){
            $('#quantity-2').trigger('click');
            $('label[for=quantity-1]').hide();
        } else {
            $('label[for=quantity-1]').show();
        }
      };
  
      // Update price in product swatches according to size and style selections --------------------
      var updateProductPrice = function(){
              $(".variant-id").each(function(){
              var price = $(this).children("option:selected").data('price');
              var compare_at_price = $(this).children("option:selected").data('compare_at_price');
              var product_id = $(this).data('product-id');
              $('#product-swatch-'+product_id+' .price').text(price);
              $('#product-swatch-'+product_id+' .compare-price').text(compare_at_price);
              if($('#product-swatch-'+product_id+' .swatch-sub-title .subtitle-price').length > 0 || $('#product-swatch-'+product_id+' .swatch-sub-title .subtitle_compare').length > 0){
                $('#product-swatch-'+product_id+' .swatch-sub-title .subtitle-price').text(price);
                $('#product-swatch-'+product_id+' .swatch-sub-title .subtitle_compare').text(compare_at_price);
              }
              $('#product-id-'+product_id).val($(this).val()); // Update variant id in product radio
          });
      };    
  
      // Update price in style swatches according to size and product selection ------------------
      var updateQtyPrice = function(){
          
          var product_id = $("input.product-radio:checked").data('product-id');        
          var size_title = $("input[name='option-size']:checked").val(); 

          if($('.product-radio:checked').data('plan') == '1-month'){
            	$('#quantity-swatches .swatch-sub-title').show();
            } else {
            	$('#quantity-swatches .swatch-sub-title').hide();
            }
          $('.quantity-radio').each(function(){
              var qty_swatch = $(this).next('label');
              // if(qty_swatch.is(':visible')){
                  
                  // var style_title = $(this).val() == 1 ? $("input[name='option-style']:checked").val() : '1 of each'; 
                  var style_title = $(this).val(); 
                  var variant_title = size_title + ' / ' + style_title;
                  var price = $("input.product-radio:checked").attr('data-price');
                  var compare_price = $("input.product-radio:checked").attr('data-price');
                  var hasthis = false;
                  $('#variant-id-'+product_id+' option').each(function(){
                    
                    if($(this).text() == variant_title){
                      price = $(this).data('price');
                      compare_price = $(this).data('compare_at_price');
                      hasthis = true;
                      qty_swatch.show();
                      console.log($(this).text() +' == '+ variant_title);
                    }
                    });
                  if(hasthis == false){
                    qty_swatch.hide();
                    $('.quantity-radio:eq(0)').trigger('click');
                    // $('.quantity-radio:eq(0)').next('label').addClass('selected');
                  }
                  // var price = $('#variant-id-'+product_id+' option').filter(function() {
                  //     return $(this).text() == variant_title;
                  // }).data('price');
                  // var compare_price = $('#variant-id-'+product_id+' option').filter(function() {
                  //     return $(this).text() == variant_title;
                  // }).data('compare_at_price');
                // console.log('price='+price);
                // console.log('compare_price='+compare_price);
                  if(price == undefined){
                    qty_swatch.find('.price').html($("input.product-radio:checked").attr('data-price'));
                  }else{
                    qty_swatch.find('.price').html(price);
                  }
                  if(compare_price == undefined){
                    qty_swatch.find('.compare-price').html($("input.product-radio:checked").attr('data-price'));
                  }else{
                    qty_swatch.find('.compare-price').html(compare_price);
                  }
              // }
          });
      };
  
      //Add a selected class
      var selectSwatch = function (label_for){
          $('label[for='+label_for+']').parents('.swatch-group-wrapper').find('.selected').removeClass('selected');
          $('label[for='+label_for+']').addClass('selected');
      };

      // Set subscription options according to the values from cookie -----------------
      var cookie_data = cookieRead('subscription_data');
      if(cookie_data){
          cookie_data = JSON.parse(cookie_data);
          console.log(cookie_data);
          $('#product-id-'+cookie_data.product_id).prop("checked", true);
          selectSwatch('product-id-'+cookie_data.product_id);

          $(".size-radio").each(function(){
              if($(this).val() == cookie_data.size){
                  $(this).prop("checked", true);
                  selectSwatch($(this).attr('id'));
              }
          });
          $(".quantity-radio").each(function(){
              if($(this).val() == cookie_data.quantity){
                  $(this).prop("checked", true);
                  selectSwatch($(this).attr('id'));
              }
          });
          $(".style-radio").each(function(){
              if($(this).val() == cookie_data.style){
                  $(this).prop("checked", true);
                  selectSwatch($(this).attr('id'));
              }
          });          

          var style_title = getStyleTitle();
          var variant_title = cookie_data.size + ' / ' + style_title;
          setVariant(variant_title);
          updateProductPrice();
          updateQtyPrice();

          if(cookie_data.size.includes("kid's")){
            //$('#style-swatches label').addClass('selected');
            //$('#style-swatches input').attr('disabled', 'disabled');
            $('label[for=quantity-1]').hide();
          }
          if(cookie_data.quantity == 2){
            $('#style-swatches label').addClass('selected');
            $('#style-swatches input').attr('disabled', 'disabled');
          }
  
          $("input[name='gift-recipient-email']").val(cookie_data.gift_recipient_email);
          $("#datepicker-gift-email-date").datepicker("setDate", cookie_data.gift_email_date);
          $("#datepicker-shipping-date").datepicker("setDate", cookie_data.shipping_date);
          $("#gift-message").val(cookie_data.gift_message);

          if(cookie_data.make_this_gift == 1){
            $("#make-this-gift").prop('checked', true);
            selectSwatch('make-this-gift');
            $('#subscription-gift-form').show();
          } else {
            $("#not-gift").trigger('click');
            selectSwatch('not-gift');
          }
      } else {
          setTimeout(function(){
            updateQtyPrice();
          },1500);
          
          $(".toggle-gift-radio:first").prop('checked', true);
          $(".product-radio:first").prop('checked', true);        
          $(".size-radio:first").prop('checked', true);
          $(".quantity-radio:first").prop('checked', true);
          $(".style-radio:first").prop('checked', true);
          selectSwatch($(".toggle-gift-radio:first").attr('id'));
          selectSwatch($(".product-radio:first").attr('id'));
          selectSwatch($(".size-radio:first").attr('id'));
          selectSwatch($(".quantity-radio:first").attr('id'));
          selectSwatch($(".style-radio:first").attr('id'));       
      }
  
      // When clicked on style swatch
      $('.toggle-gift-radio').change(function() {
        if ($(this).is(':checked')) {
            selectSwatch($(this).attr('id'));
        }
        var is_gift = $("input[name='make-this-gift']:checked").val();
        if(is_gift == 1) {
            $('#subscription-gift-form').slideDown();
        } else {
            $('#subscription-gift-form').slideUp();
        }
      });
  
      // When clicked on product swatch
      $('.product-radio').change(function() {
          if ($(this).is(':checked')) {
            var size_title = $("input[name='option-size']:checked").val();
            var style_title = getStyleTitle();
            var variant_title = size_title + ' / ' + style_title;
            setVariant(variant_title);
            updateProductPrice();
            updateQtyPrice();
            selectSwatch($(this).attr('id'));
            if($(this).data('plan') == '1-month'){
            	$('#quantity-swatches .swatch-sub-title').show();
            } else {
            	$('#quantity-swatches .swatch-sub-title').hide();
            }
          }
      });  
  
      // When clicked on size swatch
      $('.size-radio').change(function() {
          if ($(this).is(':checked')) {
              var size_title = $(this).val();
              var style_title = getStyleTitle();
              var variant_title = size_title + ' / ' + style_title;
              setVariant(variant_title);
              showHideQuantity(size_title);
              updateProductPrice();
              updateQtyPrice();              
              selectSwatch($(this).attr('id'));
          }
      });

      $('.quantity-radio').change(function() {
        if ($(this).is(':checked')) {
            var size_title = $("input[name='option-size']:checked").val();
            var style_title = getStyleTitle();
            var variant_title = size_title + ' / ' + style_title;
            // setVariant(variant_title);
            // if($(this).val() == 3){
            //     $('#style-swatches label').addClass('selected');
            //     $('#style-swatches input').attr('disabled', 'disabled');
            //   	$('#style-swatches .swatch-group-title').text('You get 1 of each style each month.');
            // } else {
            //     $('#style-swatches label').removeClass('selected');
            //     $('#style-swatches input').removeAttr('disabled');
            //   	$('#style-swatches .swatch-group-title').text('Select Sock Craziness');
            //     // var selected_id = $("input[name='option-style']:checked").attr('id');
            //     var selected_id = $("input[name='option-quantity']:checked").attr('id');
            //     selectSwatch(selected_id);
            // }
          setVariant(variant_title);
          showHideQuantity(size_title);
          updateProductPrice();
          updateQtyPrice();              
          selectSwatch($(this).attr('id'));
            // updateProductPrice();
            // selectSwatch($(this).attr('id'));
        }
      });
  
      // When clicked on style swatch
      $('.style-radio').change(function() {
          if ($(this).is(':checked')) {
              var style_title = $(this).val();
              var size_title = $("input[name='option-size']:checked").val();
              var variant_title = size_title + ' / ' + style_title;
              setVariant(variant_title);
              updateProductPrice();
              selectSwatch($(this).attr('id'));
          }
      });
  
      $('#subscription-gift-form input').on('change', function(){
          if($(this).val() != ''){
              $(this).removeAttr('style');
          }
      });
  
      // Submit product form --------------------------------------------
      jQuery("#subscription_product_form").submit(function(e) {
          e.preventDefault(); 

          $("#subscription_product_form").find('button').addClass('loading');
          var make_this_gift = $("input[name='make-this-gift']:checked").val();            
          var gift_email_date = $("#datepicker-gift-email-date").datepicker().val();
          //var shipping_date = $("#datepicker-shipping-date").datepicker().val();
  
          // Gift form validation
          var form_valid = true;
          if(make_this_gift == 1){              
              if(!isEmail($('#gift-recipient-email').val())){
                  $('#gift-recipient-email').css('border-color', 'red');
                  var focus_on = $('#gift-recipient-email');
                  form_valid = false;
              }
              if($.trim(gift_email_date) == ''){
                  $('#datepicker-gift-email-date').css('border-color', 'red');
                  if(typeof focus_on == 'undefined'){
                      var focus_on = $('#datepicker-gift-email-date');
                  }
                  form_valid = false;
              }
              if($.trim($('#gift-message').val()) == ''){
                  $('#gift-message').val('').css('border-color', 'red');
                  if(typeof focus_on == 'undefined'){
                      var focus_on = $('#gift-message');
                  }
                  form_valid = false;
              }
          }
  
          if(form_valid == false){
              $('.subscription-popup-wrapper').animate({
                  scrollTop: $("#subscription-gift-form").offset().top
              }, 1000);
              focus_on.focus();
              return false;
          }
          //$('.preloader').show();
  
          $.ajax({
              type: "POST",
              url: '/cart/clear.js',
              dataType: 'json',
              success: function() {
                  var cookieData = {};  
                  var variant_id = $(".product-radio:checked").val();                
                  var product_index = $(".product-radio").index($(".product-radio:checked")); 
                  var data_arr = {};
  
                  data_arr["id"] = variant_id;
                  data_arr["quantity"] = 1; 
                
                  if(product_index == 0){
                      data_arr['selling_plan'] = $(".product-radio:checked").attr('data-sellplan-id');
                      data_arr["properties[__appstle-selected-selling-plan]"] = $(".product-radio:checked").attr('data-sellplan-id');
                      if($('#make-this-gift:checked').length > 0){
                        var currentdate= new Date().toISOString().replace(/.\d+Z$/g, "Z");
                        data_arr["properties[_order-date]"] = currentdate;
                      }
                      // data_arr["properties[shipping_interval_frequency]"] = 1;
                      // data_arr["properties[shipping_interval_unit_type]"] = 'Months';
                      // data_arr["properties[charge_interval_unit_type]"] = 'Months';
                      // data_arr["properties[charge_interval_frequency]"] = 1;
                      /*if(product_index == 1){
                          data_arr["properties[charge_interval_frequency]"] = 6;
                          data_arr["properties[number_charges_until_expiration]"] = 50;
                      } else if(product_index == 2){
                          data_arr["properties[charge_interval_frequency]"] = 12;
                          data_arr["properties[number_charges_until_expiration]"] = 50;
                      } else {
                          data_arr["properties[charge_interval_frequency]"] = 1;
                      }*/
                  }                
  
                  if(make_this_gift == 1){                    
                      data_arr["properties[Gift Recipient Email]"] = $("#gift-recipient-email").val();
                      data_arr["properties[Date to Email Gift Message]"] = $('#datepicker-gift-email-date').val();
                      data_arr["properties[Gift Message]"] = $("#gift-message").val();
                      data_arr["properties[Shipping Date]"] = $('#datepicker-shipping-date').val();
                  }
                  //data_arr["attributes[clientId]"] = ga.getAll()[0].get('clientId');
                
                  var utm_attr = getUTMAttributes();
                  if(utm_attr){
                    //console.log(utm_attr);
                    jQuery.each(utm_attr, function(key, value) {
                      data_arr["attributes["+key+"]"] = value;
                    });
                  }
                
                  var data_str = JSON.stringify(data_arr);
                  var data = JSON.parse(data_str);
                  console.log('datadata= ',data);
                // return false;
                  cookieData['product_id'] = $(".product-radio:checked").data('product-id');
                  cookieData['variant_id'] = variant_id;
                  cookieData['size'] = $("input[name='option-size']:checked").val();
                  cookieData['quantity'] = $("input[name='option-quantity']:checked").val();
                  cookieData['style'] = $("input[name='option-style']:checked").val();
                  cookieData['make_this_gift'] = make_this_gift;
                  if(make_this_gift == 1){
                      cookieData['gift_recipient_email'] = $("#gift-recipient-email").val();
                      cookieData['gift_email_date'] = $('#datepicker-gift-email-date').val();
                      cookieData['gift_message'] = $("#gift-message").val();
                      cookieData['shipping_date'] = $('#datepicker-shipping-date').val();
                  }
                  var subscription_data = JSON.stringify(cookieData);
  
                  $.ajax({
                      type: 'POST',
                      url: '/cart/add.js',
                      data: data,
                      dataType: 'json',
                      async: false,
                      success: function() {
                          cookieErase('subscription_data');
                          cookieCreate('subscription_data', subscription_data, 7);
  
                          function get_cookie(name) {
                              return (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0)[2]
                          }
                          do {
                              token = get_cookie('cart');
                          } while (token == undefined);
  
                          /*try {
                              var ga_linker = ga.getAll()[0].get('linkerParam')
                          } catch (err) {
                              var ga_linker = ''
                          }*/
                          var ga_linker = '';
                          var discount_code = get_cookie('discount_code');
                          if(discount_code){
                              var customer_param = 'discount='+discount_code;
                          }
                          // if(product_index == 0){
                          //     window.location.href = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" + Shopify.shop + "&cart_token=" + token + "&" + customer_param + "&" + ga_linker;
                          // } else {
                            window.location.href = '/checkout';
                          // }
                      },
                      error:function(jqXHR,textStatus,errorThrown){
                        var response=$.parseJSON(jqXHR.responseText);
                        alert(response.description);
                      }
                  });
              }
          });
      });

  });